import React from 'react';
import { Option, Select } from '@fiverr-private/forms';
import { Values } from '@fiverr-private/dropdown';
import { ItemValue } from '../../../../../../types';

interface SingleSelectProps {
  label: string;
  onChange: (values: Values) => void;
  value: ItemValue;
  options: string[];
}

export const SingleSelect = ({ label, onChange, value, options }: SingleSelectProps) => (
  <Select placeholder={label} onChange={onChange} value={{ item: value }}>
    <Option value={''}>&nbsp;</Option>
    {options.map((value) => (
      <Option value={value} key={value}>
        {value}
      </Option>
    ))}
  </Select>
);
